import React, { useEffect, useState } from "react";
import { Link } from "react-router-dom";
import "./DisplayDates.css";
import axios from "axios";
import { config } from "../../../confi";
import ReceiptList from "./ReceiptList";
import SpecialDatePicker from "./Calender";
import Bigcalender from "./../../big_calender/Big_calender"

function DisplayDates() {
  const [show, setShow] = useState(false);
  const [resdata, setresdata] = useState(false);
  const [checkdate, setcheckdate] = useState("");
  const [loading, setLoading] = useState(false);
  const [flash, setflash] = useState(false);
  const [msg, setmsg] = useState("");
  const [msg_R, setmsg_R] = useState("");
  const [available, setavailable] = useState(false);

  const input_handler = (e) => {
    setcheckdate(e.target.value);
  };

  // console.log(checkdate);

  // ------function for check date slot-----////////////

  const FetchHandler = async (e) => {
    e.preventDefault();

    setsuccess(false);
    setsuccess2(false);
    setsuccess3(false);
    setShow(false);
    if (checkdate === "") {
      return;
    }
    setavailable(false);

    let reqbody = JSON.stringify({
      fn: "common_fun",
      an: "fn_ck",
      payload: { dis_date: checkdate },
    });

    try {
      setLoading(true);
      setShow(false);

      const response = await axios.post(
        `${config.apiBaseURL}/root`,
        { data: reqbody },
        {
          headers: { "Content-Type": "application/json" },
        }
      );
      // console.log(response);

      if (response.status === 200 && response.data.status === "0") {
        setresdata(response.data.data);
        setflash(true);
        setmsg(`available : ${3 - response.data.data.length} slot`);
        setShow(true);
        if (response.data.msg == "available") {
          // console.log("available", response.data.msg);
          setavailable(true);
        }
        if (response.data.data.length > 0) {
        } else {
        }
      } else {
        setflash(true);
        setmsg("not free please select another date");
      }
    } catch (error) {
      console.log(error);
    }
    setLoading(false);
  };

  //---------function for fetch member and miti info-------////////////

  const fetch_miti = async (member_recient) => {
    let reqbody = JSON.stringify({
      fn: "common_fun",
      an: "fn_fe_mi_di",
      payload: { member_reciet_no: member_recient },
    });

    try {
      const response = await axios.post(
        `${config.apiBaseURL}/root`,
        { data: reqbody },
        {
          headers: { "Content-Type": "application/json" },
        }
      );
      return response;
    } catch (error) {
      console.log(error);
    }
  };

  // -//////--------function for book date----//////////
  const handleSubmit_date = async (miti_id, date, dis_name,member_row_id) => {
    let reqbody = JSON.stringify({
      fn: "common_fun",
      an: "fn_bo",
      payload: {
        miti_ref: miti_id,
        dis_date: date,
        dis_name: dis_name,
        member_id:member_row_id
      },
    });

    try {
      const response = await axios.post(
        `${config.apiBaseURL}/root`,
        { data: reqbody },
        {
          headers: { "Content-Type": "application/json" },
        }
      );

      return response;
    } catch (error) {
      console.log(error);
    }
  };

  ////////////////////

  let [success, setsuccess] = useState(false);
  let [success2, setsuccess2] = useState(false);
  let [success3, setsuccess3] = useState(false);
  let [hindi_tithi, sethindi_thihi] = useState("");

  const success_msg = (no, msg) => {
    console.log(no, "from success");

    if (no === "1") {
      setmsg_R(msg);
      setsuccess(no);
    }

    if (no === "2") {
      setmsg_R(msg);
      setsuccess2(no);
    }

    if (no === "3") {
      setmsg_R(msg);
      setsuccess3(no);
    }
  };

  //--------------------------////////////////

  function dateupdate(date_str, special) {
    // console.log(date_str, special, "hih");

    setcheckdate(date_str);
    sethindi_thihi(special);
  }

  return (
    <>
      <div className="MittiDetails">
        <div className="button-Dates">
          <button>Display Dates</button>
        </div>
        <div className="book">
          <p style={{ color: "blue" }}>Block Mitti Date</p>
        </div>
        <div className="Fetch-Receipt">
          <div>
            <label className="MittiDetails-label">Date: {hindi_tithi}</label>
            <br />
            <div className="need-Fetch-Receipt">
              {/* <input
                className="MittiDetails-input"
                type="date"
                value={checkdate}
                onChange={input_handler}
              ></input> */}
              <SpecialDatePicker dateupdate={dateupdate} />
              <div>
                <button className="a-fetch-button" onClick={FetchHandler}>
                  Fetch
                </button>
              </div>
            </div>
          </div>
        </div>
      </div>
      <div>
        {flash && <p style={{ color: "green" }}>{msg}</p>}

        {success === "1" ? (
          <p className="book_msg"> {msg_R}</p>
        ) : (
          <ReceiptList
            no="1"
            available={available}
            status={show}
            free_date={checkdate}
            fetch_miti={fetch_miti}
            book_date={handleSubmit_date}
            res_data={resdata.length > 0 ? resdata[0] : {}}
            inputDisabled={resdata.length > 0 ? true : false}
            buttonDisabled={resdata.length > 0 ? true : false}
            success_msg={success_msg}
          />
        )}
        {success2 === "2" ? (
          <p className="book_msg"> {msg_R} </p>
        ) : (
          <ReceiptList
            no="2"
            available={available}
            status={show}
            free_date={checkdate}
            fetch_miti={fetch_miti}
            book_date={handleSubmit_date}
            res_data={resdata.length > 1 ? resdata[1] : {}}
            inputDisabled={resdata.length > 1 ? true : false}
            buttonDisabled={resdata.length > 1 ? true : false}
            success_msg={success_msg}
          />
        )}

        {success3 === "3" ? (
          <p className="book_msg"> {msg_R}</p>
        ) : (
          <ReceiptList
            no="3"
            available={available}
            status={show}
            free_date={checkdate}
            fetch_miti={fetch_miti}
            book_date={handleSubmit_date}
            res_data={resdata.length > 2 ? resdata[2] : {}}
            inputDisabled={resdata.length > 2 ? true : false}
            buttonDisabled={resdata.length > 2 ? true : false}
            success_msg={success_msg}
          />
        )}
      </div>
    </>
  );
}

export default DisplayDates;
